import React, { Component } from 'react';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import { Field, reduxForm, reset } from 'redux-form';
import Highcharts from 'highcharts';
import { renderAutoCompleteWithFloatingLabel, renderAutoCompleteSingleSelect, renderCheckBox, renderDateField } from '../components/reduxFields';


const validateForm = (values) => {
    // console.log("values",values);
    const errors = {};

    if (values.FromAuthorizationDate && values.ToAuthorizationDate) {
        const fromDate = new Date(values.FromAuthorizationDate);
        const toDate = new Date(values.ToAuthorizationDate);

        if (fromDate > toDate) {
            errors.FromAuthorizationDate = "From Date cannot be later than To Date. Please enter valid dates.";
        }
    }
    if (!values.authorizationViewIds || values.authorizationViewIds === undefined) {
        errors.authorizationViewIds = 'Please select authorization view';
    }

    return errors;

}

const validateAuthorizationPatientIds = (authorizationIds) => {
     if (!authorizationIds || !authorizationIds.length) {
        return 'Please select client';
      }
};

const stylescss = {
    block: {
      maxWidth: 250,
    },
    checkbox: {
      marginBottom: 16,
    },
  };

class AuthorizationUtilization extends Component {
    
    constructor(props) {
        super(props);        
        this.state = {        
            xAxisDateOption: [],  
            isReset: false,
            AuthorizationUtilizationViewlist: [{ id: '1', value: 'Total View' }, { id: '2', value: 'Monthly View'  },{ id: '3', value: 'Weekly View'  }],
        };    
    }

    componentDidMount = () => {
        this.highchartsHandler();
    }

    componentDidUpdate = () => {
        if(this.props.financialDataAnalytics !== null) {
            this.highchartsHandler();
        }
    }

    handleReset = () => {
        this.props.dispatch(reset('AuthorizationUtilizationForm'));    
        this.props.handleResetAuthorization();
      };

     highchartsHandler = () => {
        let finalData = [];
        let xAxisLabel = 'Utilization';
        let yAxisLabel = 'Selected Dates'; 
        let viewNameTitle = this.props.authorizationActionName;
        let gridlinesWidth = this.props.hideGridlines ? 0 : 1;
     
        if (this.props.authUtilizationChart !== null && this.props.authUtilizationChart.data != null && this.props.authUtilizationChart.data.patientAuthorizationUtilizationPercentageChartModel != null  && this.props.authUtilizationChart.data.patientAuthorizationUtilizationPercentageChartModel.length > 0) {
            this.props.authUtilizationChart.data.patientAuthorizationUtilizationPercentageChartModel.map((obj, index) => {
                        let dataObj = {
                            name: obj.x,
                            y: obj.y//.toString() + '%'
                        }
                        // dataObj['name'] = obj.x;
                        // dataObj['y'] = obj.y;
                        
                        finalData.push(dataObj);
                    });
        }
        Highcharts.setOptions({
            lang: {
              thousandsSep: ','
            },
            colors: ['#50B432', '#64E572', '#DDDF00', '#ED561B', '#fa050d', '#058DC7', '#24CBE5', '#FF9655', '#FFF263']
        });
    
        Highcharts.chart('authTotalView', {
            chart: {
                type: 'column'
            },
            title: {
                text: viewNameTitle
            },
    
            yAxis: {
                gridLineWidth: gridlinesWidth,
                minorGridLineWidth: gridlinesWidth,
                title: {
                text: `<b>${xAxisLabel}</b>`
                }
            },
    
            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'middle',
                enabled: false
            },
    
            xAxis: {
                title: {
                    text: `<b>${yAxisLabel}</b>`,
                },
                type: 'category'
            },
    
            tooltip: {
                enabled: false
            },
    
            credits: {
                enabled: false
            },
    
            plotOptions: {
                series: {
                    cursor: 'pointer',
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true
                    },
                    events: {
                        legendItemClick: function () {
                            return false
                        }
                    },
                    marker: {
                        enabled: true        
                    }
                }
            },
    
            series: [
                {
                    colorByPoint: true,
                    data: finalData
                }
            ],
    
            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            layout: 'horizontal',
                            align: 'center',
                            verticalAlign: 'bottom'
                        }
                    }
                }]
            },
    
            navigation: {
                buttonOptions: {
                    verticalAlign: 'top',
                    x: -100
                }
            },
    
            lang: {
                contextButtonTitle: 'Click to open'
            },
    
            exporting: {
                buttons: {
                    contextButton: {
                        menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "downloadCSV", "downloadXLS"]
                    }
                },
                chartOptions: {
                    colors: ['#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000'],
                }
            }
        });
    }

    render(){
        const { handleSubmit } = this.props;
        return(
            <div>
                <div className="row">
                    <div className="col-sm-12">
                        <form className="readmin-form custom_form"  onSubmit={handleSubmit(this.props.loadAuthorizationUtilizationChart)}>
                            <div className="row">         
                                <div className="col-sm-3 ml-10 require">
                                    <Field name="FromAuthorizationDate"
                                    placeholder="From Date"
                                    locale="en-US"
                                    maxDate = {this.props.ToAuthorizationDate}
                                    selected={this.props.FromAuthorizationDate}
                                    onDateChange={this.props.onAuthorizationDateChange}
                                    openToYearSelection={true}
                                    component={renderDateField} />
                                </div>
                                <div className="col-sm-3 ml-10 require">
                                    <Field name="ToAuthorizationDate"
                                    placeholder="To Date"
                                    locale="en-US"
                                    minDate = {this.props.FromAuthorizationDate}
                                    selected={this.props.ToAuthorizationDate}
                                    openToYearSelection={true}
                                    onDateChange={this.props.onAuthorizationDateChange}
                                    component={renderDateField} />
                                </div>
                                <div className="col-sm-3 ml-10 mt-35">
                                    <Field name="authorizationLocationIds"
                                        label="Location"
                                        handleNewRequest={this.props.handleAuthorizationChange}
                                        options={this.props.userLocationList}
                                        component={renderAutoCompleteWithFloatingLabel}
                                    />
                                </div>                
                                <div className="col-sm-3 ml-10 mt-35">
                                    <Field name="authorizationPayerIds"
                                    label="Payer"
                                    handleNewRequest={this.props.handleAuthorizationChange}
                                    options={this.props.masterInsuranceCompanies}
                                    component={renderAutoCompleteWithFloatingLabel}
                                    />
                                </div> 
                            </div>
                            <div className="row">
                                <div className="col-sm-3 require ml-10 mt-35">
                                    <Field
                                        name="authorizationViewIds"
                                        label="Authorization View"
                                        selected={this.props.authorizationActionName}
                                        handleNewRequest={this.props.handleAuthorizationViewChange}
                                        options={this.state.AuthorizationUtilizationViewlist}
                                        component={renderAutoCompleteSingleSelect} />
                                </div>
                                <div className={(this.props.authorizationActionName === "Monthly View" || this.props.authorizationActionName === "Weekly View") ? "col-sm-3 require ml-10 mt-35" : "col-sm-3 ml-10 mt-35"}>
                                    <Field
                                        name="authorizationPatientIds"
                                        label="Client"
                                        handleNewRequest={this.props.handleAuthorizationChange}
                                        options={this.props.patientlist}
                                        component={renderAutoCompleteWithFloatingLabel}
                                        fullWidth={true}
                                        validate={(this.props.authorizationActionName === "Monthly View" || this.props.authorizationActionName === "Weekly View") ? validateAuthorizationPatientIds : null}
                                    />
                                </div>   
                                <div className="col-sm-6 ml-10 mt-35">
                                    <Field name="authorizationIds"
                                    label="authorization"
                                    handleNewRequest={this.props.handleAuthorizationChange}
                                    options={this.props.AuthorizationList}
                                    disabled={this.props.authorizationPatientIds.length === 0 ? true: false}
                                    component={renderAutoCompleteWithFloatingLabel}
                                    />
                                </div>                                 
                            </div> 
                            <div className="row">
                                <div className="col-sm-3 ml-10 mt-35">
                                    <Field
                                        name="cptCode"
                                        label="CPT Codes"
                                        handleNewRequest={this.props.handleAuthorizationChange}
                                        options={this.props.cptCodeList}
                                        component={renderAutoCompleteWithFloatingLabel}
                                        fullWidth={true}
                                    />
                                </div> 
                                <div className="col-sm-3 ml-10 mt-35">
                                    <Field
                                    name="isIncludeFutureAuthorizations"
                                    label="Include future authorizations"
                                    component={renderCheckBox}
                                    onChange={(e) => this.props.checkFutureAuthorizationsHandler(e)}
                                    style={stylescss.checkbox}
                                    />
                                </div> 
                                <div className="col-sm-3 ml-10 mt-35">
                                    <Field
                                    name="isIncludeScheduledSessions"
                                    label="Include scheduled sessions"
                                    component={renderCheckBox}
                                    onChange={(e) => this.props.checkScheduledSessionsHandler(e)}
                                    style={stylescss.checkbox}
                                    />
                                </div> 
                                <div className="col-sm-3 reset-btn btn_rt">
                                    <RaisedButton label="Filter" className="grey_btn" type="Submit" primary={true} />
                                    <RaisedButton label="Reset" className="grey_btn ml_15" onTouchTap={this.handleReset} />                                    
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className='row'>            
                    <div className='col-sm-11'>
                        {
                            this.props.loading ? "Loading..." :
                            <div>                         
                                {this.state.xAxisDateOption.length > 0 ? 
                                <div className='row'>                          
                                    <div className='col-sm-6'></div>
                                </div>   
                                : null}
                                {/* {this.props.authorizationActionName === "Total View" &&  <div id='authTotalView' style={{ height: '500px' }} />}  */}
                                <div id='authTotalView' style={{ height: '500px' }} />
                            </div>
                        }
                    </div>
                </div>       
            </div>
        )
    }
}

AuthorizationUtilization = reduxForm({
  form: 'AuthorizationUtilizationForm',
  validate: validateForm,
  enableReinitialize: true,
})(AuthorizationUtilization);

function mapStateToProps(state) {   
    // console.log('state.staff_dashboard2............',state.staff_dashboard.OrganizationFinancialKPIGraph)
   return {
     financialDataAnalytics: state.staff_dashboard ? state.staff_dashboard.OrganizationFinancialKPIGraph : {},    
     RightPanel_loading: state.staff_dashboard.RightPanel_loading,
   };
 }

export default connect(mapStateToProps, {  })(AuthorizationUtilization);


// WEBPACK FOOTER //
// ./src/adminCharts/AuthorizationUtilization.js